import React, { useState, useEffect } from "react";
import { Card } from "@/components/ui/card";
import { Brain, FolderOpen, Users, BarChart } from "lucide-react";
import { useProjects } from "@/hooks/useProjects";
import { supabase } from "@/integrations/supabase/client";

const MetricsGrid = () => {
  const { projects, isLoading: projectsLoading } = useProjects();
  const [stats, setStats] = useState({ users: 1, insights: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      setLoading(true);
      
      const { count: insightsCount, error: insightsError } = await supabase
        .from('user_ai_interactions')
        .select('*', { count: 'exact', head: true });

      // In a real app, you'd fetch the user count from a secure endpoint.
      // For now, we'll keep it at 1 for the current user.
      const userCount = 1;

      setStats({ users: userCount, insights: insightsCount || 0 });
      setLoading(false);
    };

    fetchStats();
  }, []);

  const isLoading = projectsLoading || loading;

  const metrics = [
    {
      title: "Your Projects",
      value: isLoading ? "..." : projects.length,
      icon: FolderOpen,
      change: "view all",
    },
    {
      title: "AI Insights",
      value: isLoading ? "..." : stats.insights,
      icon: Brain,
      change: "generated",
    },
    {
      title: "Active Users",
      value: isLoading ? "..." : stats.users,
      icon: Users,
      change: "on your team",
    },
    {
      title: "Performance",
      value: "92.5%",
      icon: BarChart,
      change: "uptime",
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-8">
      {metrics.map((metric) => (
        <Card key={metric.title} className="p-4 md:p-6">
          <div className="flex items-start justify-between">
            <div>
              <p className="text-sm font-medium text-gray-500">{metric.title}</p>
              <h3 className="text-xl md:text-2xl font-bold mt-1 md:mt-2">{metric.value}</h3>
              <p className="text-sm text-muted-foreground mt-1">
                {metric.change}
              </p>
            </div>
            <metric.icon className="w-5 h-5 text-primary" />
          </div>
        </Card>
      ))}
    </div>
  );
};

export default MetricsGrid;
